import { BaseGroupPlaybackControls as a } from "./atoms-v21109.js";
class e extends a {
  then(o, t) {
    return Promise.all(this.animations).then(o).catch(t);
  }
}
export {
  e as GroupPlaybackControls
};
